import angular from 'angular';

import dashboard from './dashboard/dashboard';
import graduation from './graduation/graduation';
import cms from './cms/cms';
import concept from './site/concept/concept';
import livecourse from './site/livecourse/livecourse';
import textbook from './site/textbook/textbook';
import summary from './site/summary/summary';
import barbara from './site/barbara/barbara';
import homepage from './site/homepage/homepage';
import contact from './site/contact/contact';
import press from './site/press/press';
import tc from './site/tc/tc';
import policies from './site/policies/policies';
import workbook from './site/workbook/workbook';
import buy from './site/buy/buy';
import testimonials from './site/testimonials/testimonials';
import onlineCourse from './site/onlineCourse/onlineCourse';
import corporateInquiry from './site/corporateInquiry/corporateInquiry';
import error404 from './site/error404/error404';
import thankYou from './site/thankYou/thankYou';
import paymentFailure from './site/paymentFailure/paymentFailure';

import login from './auth/login/login';
import register from './auth/register/register';
import help from './help/help'

import userSettings from './userSettings/userSettings';

import toaster from 'angularjs-toaster';
import ngAnimate from 'angular-animate';


//Section 1
import imposingTheStructure from './courses/1/1a/imposingTheStructure/imposingTheStructure';
import cementingTheRules from './courses/1/1b/cementingTheRules/cementingTheRules';
import pickingOutThePoints from './courses/1/1c/pickingOutThePoints/pickingOutThePoints';
import graspingTheMessage from './courses/1/1d/graspingTheMessage/graspingTheMessage';


// Section 2
import ideasFitTogether from './courses/2/2a/ideasFitTogether/ideasFitTogether';
import creatingQuestion from './courses/2/2b/creatingQuestion/creatingQuestion';


// Section 3
import supportingPoints from './courses/3/3zero/supportingPoints/supportingPoints';
import deductiveReasoning from './courses/3/3a1/deductiveReasoning/deductiveReasoning';
import summarizingDeductive from './courses/3/3a2/summarizingDeductive/summarizingDeductive';
import unearthingEmbeddedArguments from './courses/3/3a3/unearthingEmbeddedArguments/unearthingEmbeddedArguments';
import inductiveReasoning from './courses/3/3b1/inductiveReasoning/inductiveReasoning';
import identifyingInductivePoints from './courses/3/3b2/identifyingInductivePoints/identifyingInductivePoints';
import inductionFromDeduction from './courses/3/3b3/inductionFromDeduction/inductionFromDeduction';
import deductionToInduction from './courses/3/3b4/deductionToInduction/deductionToInduction';
import avoidingDeductiveArguments from './courses/3/3c/avoidingDeductiveArguments/avoidingDeductiveArguments';


// Section 4
import practiceInSeeing from './courses/4/4a/practiceInSeeing/practiceInSeeing';
import findingReadersQuestion from './courses/4/4b1/findingReadersQuestion/findingReadersQuestion';
import spottingSCQ from './courses/4/4b2/spottingSCQ/spottingSCQ';
import applyingSCQProcessModule from './courses/4/4c1/applyingSCQProcess';
import practiceInSeeing3 from './courses/4/4c2/practiceInSeeing3/practiceInSeeing3';


// Section 5
import defineProblem from './courses/5/5a/defineProblem/defineProblem';
import practiceDefiningProblem from './courses/5/5b/practiceDefiningProblem/practiceDefiningProblem';
import practiceDefiningProblem2 from './courses/5/5c/practiceDefiningProblem2/practiceDefiningProblem2';
import writingProposalsPlans from './courses/5/5d/writingProposalsPlans/writingProposalsPlans';

import unit6 from './courses/6/unit6';

let module = angular.module('minto.modules', [
    dashboard,
    graduation,
    cms,
    concept,
    livecourse,
    summary,
    textbook,
    barbara,
    homepage,
    contact,
    press,
    tc,
    policies,
    workbook,
    register,
    login,
    buy,
    testimonials,
    onlineCourse,
    corporateInquiry,
    error404,
    thankYou,
    paymentFailure,
    userSettings,
    toaster,
    ngAnimate,
    help,



    // Section 1 units:
    imposingTheStructure,
    cementingTheRules,
    pickingOutThePoints,
    graspingTheMessage,



    // Section 2 units:
    ideasFitTogether,
    creatingQuestion,



    // Section 3 units:
    supportingPoints,
    deductiveReasoning,
    summarizingDeductive,
    unearthingEmbeddedArguments,
    inductiveReasoning,
    identifyingInductivePoints,
    inductionFromDeduction,
    deductionToInduction,
    avoidingDeductiveArguments,



    // Section 4 units:
    practiceInSeeing,
    practiceInSeeing3,
    findingReadersQuestion,
    spottingSCQ,
    applyingSCQProcessModule,


    // Section 5 units:
    defineProblem,
    practiceDefiningProblem,
    practiceDefiningProblem2,
    writingProposalsPlans,

    // unit6

]).config(['$animateProvider', function ($animateProvider) {
    $animateProvider.classNameFilter(/angular-ngAnimate/);
  }])
  .name;

export default module;



// WEBPACK FOOTER //
// ./client/app/modules/modules.module.js